const AppCategory = (api: any) => ({
  getAppCategories: () => api.get("/appCategory/getAppCategories.php", {}, {}),
  createAppCategory: (data: any) =>
    api.post("/appCategory/createAppCategory.php", {}, data),
  searchAppCategoryRelationship: (data: any) =>
    api.post("/appCategory/searchAppCategoryRelationship.php", {}, data),
  deleteAppCategoryRelationship: (data: any) =>
    api.remove("/appCategory/deleteAppCategoryRelationship.php", {}, data),
  createAppCategoryRelationship: (data: any) =>
    api.post("/appCategory/createAppCategoryRelationship.php", {}, data),
});

export default AppCategory;